import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';



import { ItemQualityCheckListApi } from '../../api/master/itemQualityCheckList.api';
import { ItemQualityCheckList, ItemQualityCheckListData } from '../../interface/master/itemQualityCheckList';
@Injectable()
export class ItemQualityCheckListService extends ItemQualityCheckListData {

    constructor(private api: ItemQualityCheckListApi) {
      super();
    }
  
  
    list(url: string): Observable<ItemQualityCheckList[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<ItemQualityCheckList>{
        return this.api.getById(url);
    }
  
    create(url: string, data:ItemQualityCheckList): Observable<ItemQualityCheckList[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:ItemQualityCheckList): Observable<ItemQualityCheckList> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  